'use client'
import Hero from '@/components/homes/home-9/Hero'

/**
 * 把 Hero 限制在置中容器內，並強制較小高度
 * 用法：<HeroClamp banner={banner} hDesktop="45vh" hTablet="40vh" hMobile="34vh" />
 */
export default function HeroClamp({
  banner,
  hDesktop = '48vh',
  hTablet = '42vh',
  hMobile = '36vh',
  className = '',
}) {
  return (
    <>
      {/* 置中、左右縮進的外框 */}
      <div className={`hero-container w-100 p-0 ${className} mb-3`}>
        <div style={{ border: '1px solid trasnparent', overflow: 'hidden' }}>
          <Hero className="hero--compact" banner={banner} />
        </div>
      </div>

      {/* 只影響本頁的樣式 */}
      <style jsx>{`
        /* 容器：寬度上限 + 兩側 padding，置中 */
        .hero-container {
          width: min(100%, 1320px); /* 你網站的 container 寬，可調 */
          margin-inline: auto;
          padding-inline: 16px; /* 兩側縮進（gutter）*/
        }
        /* 把超出容器的影像裁掉，順便加點圓角（可刪）*/
        .hero-clip {
          overflow: hidden;
          border-radius: 12px;
        }
      `}</style>

      {/* 全域覆蓋：強制高度較小（沿用 B 方案）*/}
      <style jsx global>{`
        .hero--compact,
        .hero--compact .js-swiper-slider,
        .hero--compact .swiper,
        .hero--compact .swiper-wrapper,
        .hero--compact .swiper-slide {
          height: ${hDesktop} !important;
          max-height: ${hDesktop} !important;
          min-height: 0 !important;
        }
        .hero--compact img {
          object-fit: cover !important;
        }

        @media (max-width: 1199px) {
          .hero--compact,
          .hero--compact .js-swiper-slider,
          .hero--compact .swiper,
          .hero--compact .swiper-wrapper,
          .hero--compact .swiper-slide {
            height: ${hTablet} !important;
            max-height: ${hTablet} !important;
          }
        }
        @media (max-width: 767px) {
          .hero--compact,
          .hero--compact .js-swiper-slider,
          .hero--compact .swiper,
          .hero--compact .swiper-wrapper,
          .hero--compact .swiper-slide {
            height: ${hMobile} !important;
            max-height: ${hMobile} !important;
          }
        }
      `}</style>
    </>
  )
}
